import type { UseFormReturn } from 'react-hook-form'
import type {
  GenerateRiskOutResult,
  RiskOutFitAssessment,
  RiskOutGenerationMode,
} from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { CreateHazardRiskReductionStepFormValues } from './CreateHazardRiskReductionStepForm.schema'

function getFitAssessment(
  result: GenerateRiskOutResult
): RiskOutFitAssessment | null {
  if (!('fitStatus' in result)) {
    return null
  }

  if (result.fitStatus === 'incompatible') {
    return {
      fitStatus: result.fitStatus,
      fitSummary: result.fitSummary,
    }
  }

  return null
}

export function applyRiskOutGenerationResult(
  form: UseFormReturn<CreateHazardRiskReductionStepFormValues>,
  mode: RiskOutGenerationMode,
  result: GenerateRiskOutResult
): RiskOutFitAssessment | null {
  const fitAssessment = getFitAssessment(result)
  const isIncompatible =
    'fitStatus' in result && result.fitStatus === 'incompatible'

  // Incompatible fit: server returns Risk In dimensions (no agent reduction); apply so
  // later steps pick up the previous step cap (e.g. frequency) without invalid defaults.
  if (mode === 'dimensions' || mode === 'both') {
    if ('riskOutInjury' in result) {
      form.setValue('riskOutInjury', result.riskOutInjury)
      form.setValue('riskOutFrequency', result.riskOutFrequency)
      form.setValue('riskOutAvoidance', result.riskOutAvoidance)
      form.setValue('riskOutLikelihood', result.riskOutLikelihood)
    }
  }

  if (!isIncompatible && (mode === 'justifications' || mode === 'both')) {
    if ('riskOutInjuryJustification' in result) {
      form.setValue(
        'riskOutInjuryJustification',
        result.riskOutInjuryJustification
      )
      form.setValue(
        'riskOutFrequencyJustification',
        result.riskOutFrequencyJustification
      )
      form.setValue(
        'riskOutAvoidanceJustification',
        result.riskOutAvoidanceJustification
      )
      form.setValue(
        'riskOutLikelihoodJustification',
        result.riskOutLikelihoodJustification
      )
    }
  }

  form.clearErrors()

  return fitAssessment
}
